import { useState } from 'react';
import { todayIso } from '@platform/core/lib/format';
import { useCreateRecordMutation, useMeQuery } from '@platform/state/api';
import type { ISubTableAdd } from './ISubTableAdd';
import type { ISubTableDef } from './ISubTableDef';
import { missingRequired } from './missingRequired';
import { subTableDefaults } from './subTableDefaults';

/**
 * «+ Додати» підтаблиці на місці (прототип v4 onAdd — рядок з'являється одразу, без діалогу): типові значення (вибір — перший варіант,
 * особа — я, посилання — батько); коли їх досить для обов'язкових полів, рядок одразу створюється на сервері й стає в кінець таблиці;
 * інакше з'являється новий рядок-чернетка, який створюється, щойно заповнено обов'язкові клітинки (× відкидає його; поки він є, «+ Додати»
 * другого не додає).
 */
export function useSubTableAdd(ws: string, def: ISubTableDef, parentId: string): ISubTableAdd {
  const { data: me } = useMeQuery();
  const [create, { isLoading, error, reset }] = useCreateRecordMutation();
  const [draft, setDraft] = useState<Record<string, unknown> | null>(null);
  const save = (values: Record<string, unknown>) => {
    if (missingRequired(def.child, values).length) { setDraft(values); return; }
    reset();
    setDraft(null);
    void create({ ws, rt: def.child.key, body: { values } }).unwrap().catch(() => setDraft(values));
  };
  return {
    draft,
    busy: isLoading,
    error,
    start: () => { if (!draft) save(subTableDefaults(def, parentId, me?.id, todayIso())); },
    setField: (key, value) => { if (draft) save({ ...draft, [key]: value }); },
    discard: () => { setDraft(null); reset(); },
  };
}
